<div *ngIf="showAbandonedCart && !actRout?.snapshot?.queryParams?.st && !(vars.userData | async)?.listsubscriptions?.medical" (click)="navigate()" class="abandoned-cart-wrapper">
  <button class="close-ico" mat-icon-button  (click)="close()"><mat-icon>close</mat-icon></button>
  <img data-src="/assets/images/portfolio/life_in_bucket.png" alt="">
  <div class="abandoned-cart-content">
    <div class="text-1">You’re Just <strong>1 step away</strong></div>
    <div class="text-2">Tap to give monthly & <strong>save 12 lives/yr</strong></div>
  </div>
  <i class="material-icons">arrow_forward_ios</i>
</div>
